import styled from "styled-components";

/* ── Summary strip ────────────────────────────────── */
export const SummaryStrip = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex-wrap: wrap;
  padding: 0.625rem 0;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  margin-top: 0.5rem;
`;

export const SummaryChip = styled.div<{ $variant: "paid" | "forecast" | "total" }>`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  .chip-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    flex-shrink: 0;
    background: ${({ $variant }) =>
      $variant === "paid"
        ? "#15803d"
        : $variant === "forecast"
        ? "#b45309"
        : "var(--primary)"};
  }

  .chip-label {
    font-size: 0.6875rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #9ca3af;
  }

  .chip-value {
    font-size: 0.9375rem;
    font-weight: 700;
    color: ${({ $variant }) =>
      $variant === "paid"
        ? "#15803d"
        : $variant === "forecast"
        ? "#b45309"
        : "var(--primary)"};
  }
`;

/* ── Calendar shell (loading overlay) ────────────── */
export const CalendarShell = styled.div`
  position: relative;
`;

export const CalendarLoading = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.55);
  border-radius: var(--border-radius);

  body.dark & {
    background: rgba(0, 0, 0, 0.35);
  }
`;

export const RuleHint = styled.p`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.8125rem;
  color: var(--text-muted);
  margin: 0 0 0.75rem;

  i {
    color: var(--primary);
    font-size: 1rem;
  }
`;

/* ── Calendar event content ──────────────────────── */
export const EventWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.2rem 0.3rem;
  width: 100%;
  cursor: pointer;
`;

export const EventPill = styled.span<{
  $type: "paid" | "forecast" | "repasse" | "repasse-pending";
}>`
  display: inline-flex;
  align-items: center;
  gap: 0.2rem;
  font-size: 0.6875rem;
  font-weight: 700;
  padding: 0.125rem 0.4rem;
  border-radius: 2rem;
  white-space: nowrap;
  line-height: 1.4;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;

  ${({ $type }) =>
    $type === "paid" &&
    `
    background: rgba(21,128,61,0.12);
    color: #15803d;
  `}

  ${({ $type }) =>
    $type === "forecast" &&
    `
    background: rgba(180,83,9,0.1);
    color: #b45309;
  `}

  ${({ $type }) =>
    $type === "repasse" &&
    `
    background: rgba(var(--primary-rgb),0.12);
    color: var(--primary);
  `}

  ${({ $type }) =>
    $type === "repasse-pending" &&
    `
    background: rgba(107,114,128,0.1);
    color: #6b7280;
  `}

  i { font-size: 0.7rem; }
`;
